import React, { Component } from 'react'
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import FormControl from 'react-bootstrap/FormControl';
import { FormattedMessage, injectIntl } from 'react-intl';
import cx from 'classnames';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';

import CustomPagination from '../../CustomPagination/CustomPagination';
import Link from '../../Link/Link';

import messages from '../../../locale/messages';
import removeCancelReason from '../../../actions/siteadmin/removeCancelReason';
import { capitalizeFirstLetter } from '../../../helpers/capitalizeFirst';

import TrashIcon from '../../../../public/Icons/bin.svg';
import EditIcon from '../../../../public/Icons/edit.png';
import s from './CancellationReasonList.css';
export class CancellationReason extends Component {

    static propTypes = {
        cancelReasons: PropTypes.object,
    }

    constructor(props) {
        super(props)

        this.state = {
            currentPage: 1,
            isDisabled: 0
        }
    }

    handleDelete = async (id, currentPage) => {
        const { cancelReasons: { refetch, getAllCancelReason }, removeCancelReason } = this.props;
        this.setState({
            isDisabled: true
        })
        let variables = { currentPage: currentPage > 1 && getAllCancelReason?.result?.length == 1 ? currentPage - 1 : currentPage };
        const response = await removeCancelReason(id, currentPage);
        if (response?.status == 200) {
            this.setState({ currentPage: variables.currentPage });
            refetch(variables)
        }
    }

    handleSearchClick = async (searchList) => {
        const { cancelReasons: { refetch } } = this.props
        let variables = {
            currentPage: 1,
            searchList: searchList
        }
        this.setState({ currentPage: 1 })
        refetch(variables)
    }

    handleSearchChange = async (e) => {
        let self = this
        if (self.state.typingTimeout) {
            clearTimeout(self.state.typingTimeout)
        }
        self.setState({
            searchList: e.target.value,
            typing: false,
            typingTimeout: setTimeout(function () {
                self.handleSearchClick(self.state.searchList)
            }, 450)
        })
    }

    paginationData = async (currentPage) => {
        const { cancelReasons: { refetch } } = this.props;
        let variables = { currentPage };
        this.setState({ currentPage });
        refetch(variables);
    }

    render() {
        const { cancelReasons } = this.props;
        const { currentPage } = this.state;
        const { formatMessage } = this.props.intl;
        return (
            <div className={cx(s.widthInner, s.tableSection, 'whiteDropdown', 'widthInnerNoBorder')}>
                <div className={cx(s.exportDisplay, s.tabelExport)}>
                    <div>
                        <div className={s.searchInput}>
                            <FormControl type='text' placeholder={formatMessage(messages.search)} onChange={(e) => this.handleSearchChange(e)} className={s.formControlInput} />
                        </div>
                    </div>
                    <div className={cx(s.exportTextSection, 'textAlignLeftRTL')}>
                        <div className={cx(s.paddingTop2)}>
                            <Link to={"/siteadmin/cancel-reasons/add"} className={s.addlinkBtn} ><FormattedMessage {...messages.addCancelReason} /></Link>
                        </div>
                    </div>
                </div>
                <div className={cx(s.tableCss, 'tableCss', 'tableSticky', 'NewAdminResponsiveTable')}>
                    <Table className="table">
                        <thead>
                            <tr>
                                <th scope="col"><FormattedMessage {...messages.id} /></th>
                                <th scope="col"><FormattedMessage {...messages.cancelReason} /></th>
                                <th scope="col"><FormattedMessage {...messages.cancelledBy} /></th>
                                <th scope="col"><FormattedMessage {...messages.status} /></th>
                                <th scope="col"><FormattedMessage {...messages.action} /></th>
                                <th scope="col"><FormattedMessage {...messages.deleteAction} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                cancelReasons?.getAllCancelReason?.result?.length > 0 && cancelReasons?.getAllCancelReason?.result?.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td data-label={formatMessage(messages.id)}>{item?.id}</td>
                                            <td data-label={formatMessage(messages.cancelReason)}>{capitalizeFirstLetter(item?.reason)}</td>
                                            <td data-label={formatMessage(messages.cancelledBy)}>{
                                                (item?.userType == 1 && formatMessage(messages.eaterCancel)) ||
                                                (item?.userType == 2 && formatMessage(messages.driverCancel)) ||
                                                (item?.userType == 3 && formatMessage(messages.driverUnableToDeliver)) ||
                                                (item?.userType == 4 && formatMessage(messages.restaurantDecline))
                                            }</td>
                                            <td data-label={formatMessage(messages.status)}>{item?.isActive == true ? formatMessage(messages.active) : formatMessage(messages.inactive)}</td>
                                            <td data-label={formatMessage(messages.action)}>
                                                <Link to={'/siteadmin/cancel-reasons/edit/' + item?.id} className={'editAlignIcon'}>
                                                    <span><img src={EditIcon} className={cx(s.editIcon, 'editIconRTL')} /></span>
                                                    <span className={s.vtrMiddle}>
                                                        <FormattedMessage {...messages.editAction} />
                                                    </span>
                                                </Link>
                                            </td>
                                            <td className={s.trashPadding} data-label={formatMessage(messages.deleteAction)}>
                                                <Button onClick={() => this.handleDelete(item?.id, currentPage)} className={s.iconBtn}>
                                                    <img src={TrashIcon} className={cx(s.editIcon, 'editIconRTL')} />
                                                    <span className={s.vtrMiddle}>
                                                        <FormattedMessage {...messages.deleteAction} />
                                                    </span>
                                                </Button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            {
                                ((cancelReasons?.getAllCancelReason?.result?.length == 0)) && (
                                    <tr>
                                        <td colSpan={50} className={s.noRecords}><FormattedMessage {...messages.noResult} /></td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                </div>
                {
                    cancelReasons?.getAllCancelReason?.result?.length > 0
                    && <div className={cx(s.space5, s.spaceTop5)}>
                        <CustomPagination
                            total={cancelReasons?.getAllCancelReason?.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.manageCancelReason)}
                        />
                    </div>
                }
            </div>
        )
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    removeCancelReason
};

export default injectIntl(compose(injectIntl,
    withStyles(s),
    connect(mapState, mapDispatch)
)(CancellationReason));